<template>
    <ul class="flex flex-wrap md:flex-col justify-center lg:text-left footer-nav gap-4 md:gap-2 font-semibold px-8">
        <li
            v-for="(item, index) in items"
            :key="`item-${index}`"
            class="lg:m-0"
        >
            <a
                v-if="item.component === 'a'"
                :href="item.to"
            >
                {{ item.title }}
            </a>
            <nuxt-link
                v-else
                :to="item.to"
            >
                {{ item.title }}
            </nuxt-link>
        </li>
    </ul>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    title: 'How It Works',
                    to: '/pages/how-it-works/',
                },
                {
                    title: 'Blog',
                    to: '/blog',
                    component: 'a',
                },
                {
                    title: 'Sustainability',
                    to: '/pages/sustainability-page/',
                },
                {
                    title: 'FAQ',
                    to: '/help',
                },
                {
                    title: 'About Us',
                    to: '/pages/about-us/',
                },
                {
                    title: 'Contact Us',
                    to: '/contact-us',
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
a {
    @apply no-underline;
    &:hover {
        @apply text-primary;
    }
}

.separator:last-child {
    display: none;
}
</style>
